module.exports = __webpack_public_path__ + "media/packs/images/chat-3d1bca45809c7851e259dc427f9df385.svg";